/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Suggestions_Inline_Content_ExpectedInputs */



/**
* | output |
* | --- |
* | "This change proposed a whole block where only text can go, so it could not be applied. It stays open — ask the AI to suggest it again as plain text." |
*
* @param {Suggestions_Inline_Content_ExpectedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const suggestions_inline_content_expected = /** @type {((inputs?: Suggestions_Inline_Content_ExpectedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Suggestions_Inline_Content_ExpectedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Änderung enthielt einen ganzen Block, wo nur Text stehen kann, und konnte deshalb nicht angewendet werden. Sie bleibt offen – bitte die KI, sie erneut als reinen Text vorzuschlagen.")
	return /** @type {LocalizedString} */ ("This change proposed a whole block where only text can go, so it could not be applied. It stays open — ask the AI to suggest it again as plain text.")
});